export const GET_APP_HOME_CONFIG = 'GET_APP_HOME_CONFIG';
export const UPDATE_APP_HOME_CONFIG = 'UPDATE_APP_HOME_CONFIG';
export const SET_APP_HOME_CONFIG = 'SET_APP_HOME_CONFIG';
